import { CommunityConfigurationOutput } from 'src/graphql';

import { TLngLat } from 'src/typings/base-types';

export function getConfigurationLocation(
  project: CommunityConfigurationOutput,
): TLngLat | undefined {
  const { latitude, longitude } = project;

  if (!!longitude && !!latitude) {
    return { lng: longitude, lat: latitude };
  }

  return undefined;
}
